import { Breakpoints } from "../breakpoints";

function onClick(e) {
  const target = (this._active = e.target.parentNode);

  target.classList.toggle("open");

  if (
    target.closest(".nav_left") ||
    target.classList.contains("js--maybe-left")
  ) {
    target.classList.toggle("open_left");
  } else if (
    target.closest(".nav_right") ||
    target.classList.contains("js--maybe-right")
  ) {
    target.classList.toggle("open_right");
  }

  target.classList.contains("open")
    ? document.addEventListener("click", this.onDocClickCtx)
    : document.removeEventListener("click", this.onDocClickCtx);
}

function onDocClick(e) {
  const active = this._active;
  const target = e.target; // nav__item
  // console.log("active", active);
  // console.log("target", target);
  // console.log(
  //   'target.closest(".".concat(HeaderNav.className, "__item"))',
  //   target.closest(".".concat(HeaderNav.className, "__item"))
  // );
  // console.log(
  //   'active !== target && target.closest(".".concat(HeaderNav.className, "__item")) !== active',
  //   active !== target &&
  //     target.closest(".".concat(HeaderNav.className, "__item")) !== active
  // );
  if (
    active !== target &&
    target.closest(".".concat(HeaderNav.className, "__item")) !== active
  ) {
    active.classList.remove("open", "open_right", "open_left");
    document.removeEventListener("click", this.onDocClickCtx);
  }
}

class HeaderNav {
  static className = "nav";

  _active = null;

  constructor(domElem) {
    this.domElem = domElem;
    this.items = domElem.querySelectorAll(
      `span.${HeaderNav.className}__item-link`
    );
    this.onClickCtx = onClick.bind(this);
    this.onDocClickCtx = onDocClick.bind(this);
  }

  init() {
    this.items.forEach((el) => {
      el.addEventListener("click", this.onClickCtx);
    });
  }

  destroy() {
    this.items.forEach((el) => {
      el.removeEventListener("click", this.onClickCtx);
    });
    this.closeAll();
    document.removeEventListener("click", this.onDocClickCtx);
  }

  closeAll() {
    this.items.forEach((item) => {
      item.parentNode.classList.remove("open", "open_right", "open_left");
    });
  }
}

let _instance;

/**
 * @param {HTMLElement} header
 */
export function initHeaderNav(header) {
  if (_instance && _instance.init) {
    return _instance;
  }

  const nav = header?.querySelectorAll("nav.nav");
  if (nav) {
    const ArrNav = Array.from(nav).map(function (elem) {
      return new HeaderNav(elem);
    });

    function init() {
      ArrNav.forEach(function (el) {
        return el.init();
      });
    }

    function destroy() {
      ArrNav.forEach(function (el) {
        return el.destroy();
      });
    }

    const breakpoints = {
      "md-min": () => {
        init();
      },
      "sm-max": () => {
        destroy();
      },
    };

    _instance = {
      arr: [...ArrNav],
      init,
      destroy,
      breakpoints,
    };

    return _instance;
  } else {
    return null;
  }
}
